<template>
  <div class="row">
    <div class="col-lg-12">
      <div class="form__group">
        <div class="form-control form-control--select">
          <select id="locker_country_id"
                  v-model="shipping.country_id"
                  :disabled="inProgress"
                  name="locker_country_id"
                  @input="clearValidationError('shipping.country_id')"
          >
            <option :value="null" disabled selected>{{ in18['attribute_shipping_country_option'] }}</option>
            <option v-for="country in availableCountries"
                    :key="country.id"
                    :value="country.id">
              {{ country.title }}
            </option>
          </select>
          <validation-error :errors="errors['shipping.country_id']"/>
        </div>
      </div>
    </div><!-- Country -->
  </div><!-- .row -->

  <div class="row mt-5">
    <div class="col-lg-6">
      <div class="form__group">
        <div class="form__group  form__group--md">
          <input id="shipping_city"
                 v-model="shipping.city"
                 :class="{'error' : errors['shipping.city']}"
                 class="form-control"
                 name="shipping_city"
                 type="text"
                 @input="clearValidationError('shipping.city')"
                 :disabled="inProgress"
          >
          <label class="form-label" for="shipping_city">
            {{ in18['attribute_shipping_city'] }}
            <validation-error :errors="errors['shipping.city']"/>
          </label>
          <svg class="form-control-icon">
            <use href="#form-location"></use>
          </svg>
        </div>
      </div>
    </div><!-- City -->

    <div class="col-lg-6">
      <div class="form__group">
        <div class="form__group  form__group--md">
          <input id="shipping_address"
                 v-model="shipping.address"
                 :class="{'error' : errors['shipping.address']}"
                 class="form-control"
                 name="shipping_address"
                 type="text"
                 @input="clearValidationError('shipping.address')"
                 :disabled="inProgress"
          >
          <label class="form-label" for="shipping_address">
            {{ in18['attribute_shipping_address'] }}
            <validation-error :errors="errors['shipping.address']"/>
          </label>
          <svg class="form-control-icon">
            <use href="#form-location"></use>
          </svg>
        </div>
      </div>
    </div><!-- Address -->

    <div class="col-lg-6">
      <div class="form__group">
        <div class="form__group  form__group--md">
          <input id="shipping_zip"
                 v-model="shipping.zip"
                 :class="{'error' : errors['shipping.zip']}"
                 class="form-control"
                 name="shipping_zip"
                 type="text"
                 @blur="validateZipCode"
                 @input="clearValidationError('shipping.zip')"
                 :disabled="inProgress"
          >
          <label class="form-label" for="shipping_zip">
            {{ in18['attribute_shipping_postcode'] }}
            <validation-error :errors="errors['shipping.zip']"/>
          </label>
          <svg class="form-control-icon">
            <use href="#form-location"></use>
          </svg>
        </div>
      </div>
    </div><!-- Zip -->

    <div class="col-lg-6">
      <TelFormField
        v-model="shipping.user_phone_number"
        name="mobile_phone_number"
        :id="'courier_mobile_phone_number'"
        :label="in18['attribute_user_phone']"
        :errors="phoneErrors"
        :in-progress="inProgress"
        @update:model-value="clearValidationError('shipping.user_phone_number.number');clearValidationError('shipping.user_phone_number.countryCallingCode')"
      />
    </div><!-- Phone -->

    <div class="col-lg-12">
      <div class="form__group">
          <textarea
              id="locker_message"
              v-model="shipping.message"
              :disabled="inProgress"
              :placeholder="in18['attribute_shipping_message_option']"
              class="form-control form-control--textarea"
              name="locker_message"
          />
        <validation-error :errors="errors['shipping.message']"/>
      </div>
    </div><!-- Message -->
  </div><!-- .row -->
</template>

<script>

import ValidationError from '../../../features/ValidationError.vue';
import TelFormField from '../../../components/form-field/TelFormField.vue'

export default {

  name: "Courier",

  components: {
    ValidationError,
    TelFormField
  },

  emits: [
    'update-cart',
    'country-selected',
    'update-in-progress',
    'update-error',
  ],

  props: {
    shippingMethod: {
      type:     Object,
      required: true,
    },
    shipping:       {
      type:     Object,
      required: true,
    },
    errors:         {
      type:     Object,
      required: true,
    },
    in18:           {
      type: Object,
    },
    inProgress:     {
      type: Boolean,
    },
  },

  data() {
    return {
      availableCountries: [],
      progress: false,
    }
  },

  created() {
    this.fetchCountries();
  },

  computed: {
    filteredAreas() {
      if (this.shipping.region_id === null) {
        return [];
      }
      const selectedRegion = this.availableRegions.find(region => region.id === this.shipping.region_id);
      return selectedRegion ? selectedRegion.areas : [];
    },
    phoneErrors() {
      let errors = []
      if (this.errors['shipping.user_phone_number.number']) {
        errors = errors.concat(this.errors['shipping.user_phone_number.number'])
      }
      if (this.errors['shipping.user_phone_number.countryCallingCode']) {
        errors = errors.concat(this.errors['shipping.user_phone_number.countryCallingCode'])
      }
      return errors
    },
  },

  methods: {

    validateZipCode() {
      // Notify the parent component about the progress update
      this.$emit('update-in-progress', true);

      return axios.post(`/api/countries/${this.shippingMethod.id}/${this.shipping.country_id}/validate-zip-code`, {'shipping': this.shipping}).then((response) => {
        this.$emit('update-cart', response.data.cart);
        ga_add_shipping_info_event(response.data.cart);
      }).catch((error) => {
        window.toastr.error(error.response.data.message);
        this.$emit('update-error', 'shipping.zip', error.response.data.errors['shipping.zip']);
      }).finally(() => {
        // Notify the parent component that the operation is complete
        this.$emit('update-in-progress', false);
      });
    },

    clearValidationError(fieldName) {
      if (this.errors[fieldName]) {
        this.errors[fieldName] = null;
      }
    },

    fetchCountries() {

      if (!this.shippingMethod) {
        return;
      }

      // Notify the parent component about the progress update
      this.$emit('update-in-progress', true);

      return axios.get(`/api/shipping/${this.shippingMethod.id}/countries`).then((response) => {
        this.availableCountries = response.data.countries;
      }).catch((error) => {
        window.toastr.error(error.response.data.message);
      }).finally(() => {
        // Notify the parent component that the operation is complete
        this.$emit('update-in-progress', false);
      });
    },
  },
};

</script>
